module.exports = __webpack_public_path__ + "img/Maths Sharp Shooter Locked.44623f6.png";